import store from '../store/index';
import { ITEM_TYPES } from '../models/enums/betslip-constants';

/**
 * Helper service for interaction with Odds
 */
export default class OddHelperService {
  /**
   * Check if odd is active
   */
  static isOddActive(matchId, outcome) {
    return store.getters.isOddActive(matchId, outcome.id, outcome);
  }

  /**
   * Get item type
   * @param {Number} outcomeId
   * @param {String} type
   */
  static getMatchItemType(outcomeId, type) {
    if (String(outcomeId).startsWith('p-o')) {
      return ITEM_TYPES.PLAYER;
    }
    switch (type) {
      case 'prematch':
        return ITEM_TYPES.PRE_MATCH;
      case 'outright':
        return ITEM_TYPES.OUTRIGHT;
      default:
        return null;
    }
  }

  /**
   * generate empty outcomes to be used as placeholders in home widgets
   * @param {Number} numOfItems
   * @param {Boolean} shortModel
   */
  static generateEmptyOutcomes(numOfItems, shortModel = true) {
    let outcomes = [];
    const outcomeShort = {
      'col': 'undefined',
      'id': 0,
      'identifier': '',
      'n': '--',
      'ord': 'undefined',
      'o': '--',
      'sbv': '',
      'noValue': true,
    };
    const outcome = {
      'column': 'undefined',
      'id': 0,
      'identifier': '',
      'name': '--',
      'orderNo': 'undefined',
      'originalDecimalOutcome': '--',
      'sbv': '',
      'upDownClass': '',
      'noValue': true,
    };
    while (numOfItems) {
      outcomes.push(shortModel ? outcomeShort : outcome);
      numOfItems -= 1;
    }
    return shortModel ? outcomes : { outcomes: outcomes };
  }

  /**
   * return Ordered outcomes acording to column property.
   * generate empty outcomes if no outcomes.
   * @param {Object} colOdds
   * @param {Object} comboOddType
   */
  static getOrderedOutcomes(colOdds, comboOddType) {
    if (colOdds && colOdds.outcomes.length > 0) {
      let columnOdds = JSON.parse(JSON.stringify(colOdds));
      // if some of the outcomes are missing add them, and order them by the combo (mainMarkets) order.
      if (columnOdds.outcomes.length < comboOddType.o.length) {
        let outcomes = [];
        for (let i = 0; i < comboOddType.o.length; i += 1) {
          outcomes.push(columnOdds.outcomes.find(o => o.id === comboOddType.o[i].id) || this.generateEmptyOutcomes(1, false).outcomes[0]);
        }
        columnOdds.outcomes = outcomes;
        return columnOdds;
      }
      if (typeof colOdds.outcomes[0].column !== 'undefined') {
        columnOdds.outcomes.sort((a, b) => (a.column > b.column) ? 1 : -1);
      }
      return columnOdds;
    } else {
      return this.generateEmptyOutcomes(comboOddType.o.length, false);
    }
  }
  /**
   * keep the comented code here untill we find a proper solution for the ordering
   * return Ordered outcomes for a specific column acording to SBV property or if No SBV then column prop.
   * @param {array} outcomes
   * @param {Number} column
   */
  static orderColumnOutcomes(outcomes, column, isAutomaticSort) {
    // let distinctSbv = [...new Set(outcomes.map(o => o.sbv).filter(ot => ot))].sort((a, b) => a > b ? 1 : -1);
    // if we have only one SBV or ir we have no SBV  order the items by the order property
    // if (distinctSbv.length < 2) {
    return outcomes.filter(o => o.column === column).sort((el1, el2) => isAutomaticSort ?  el1.sbv > el2.sbv ? 1 : -1 : el1.orderNo > el2.orderNo ? 1 : -1);
    // }
    // // order outcomes by SBV ascending and handle missing outcomes
    // let colOutcomes = outcomes.filter(o => o.column === column).sort((el1, el2) => el1.sbv > el2.sbv ? 1 : -1);
    // let count = 1; // number of same SBV outcomes
    // let increment = count - 1; // index difference between disticntSbv and colOutcomes
    // distinctSbv.forEach((sbv, index) => {
    //   let countPrevSbv = count; // count of previos SBV items
    //   count = colOutcomes.filter(outcome => outcome.sbv === sbv.toString()).length;
    //   // if item is missing for the SBV generate empty outcome
    //   if (typeof colOutcomes[index + increment] === 'undefined' || colOutcomes[index + increment].sbv !== sbv.toString() || count < countPrevSbv) {
    //     colOutcomes.splice(index + increment, 0, this.generateEmptyOutcomes(1, false).outcomes[0]);
    //     count += 1;
    //   }
    //   increment += (count - 1);
    // });
    // return colOutcomes;
  }

  static getOrderOutcomesAwayAtHome(outcomes, awayAtHome, column, isLive) {
    let filter = isLive ? outcomes.filter(a => a.column === column) : outcomes;
    let firstRow = awayAtHome === true ? filter[1] : filter[0];
    let secondRow = awayAtHome === true ? filter[0] : filter[1];
    return column === 1 ? firstRow : secondRow;
  }
  /**
   * keep the comented code here untill we find a proper solution for the ordering
   * return Ordered outcomes for a specific column acording to SBV property or if No SBV then column prop.
   * @param {array} outcomes
   * @param {Number} column
   */
  static orderSlicedColumnOutcomes(outcomes, column, isAutomaticSort) {
    let visibleOdds = +APP_SETTINGS.settings.outcomesToShowByDefault || undefined;
    return outcomes.filter(o => o.column === column).sort((el1, el2) => isAutomaticSort ?  el1.sbv > el2.sbv ? 1 : -1 : el1.orderNo > el2.orderNo ? 1 : -1).slice(0, visibleOdds);
  }
}
